import { createSlice, isFulfilled, isPending, isRejected, PayloadAction } from '@reduxjs/toolkit';
import { showApiErrors } from '@/utils';
import { BannersState, BANNERS_SLICE_NAME, initialState } from './models';
import { createBanner, getBanner, deleteBanner, getBannersList, reorderBanners, editBanner } from './actionCreators';
import { TGetBannersQuery } from '../helpers';
import { IPagination } from '@/models/pagination.model';
import { IBanner } from '@/models/banners.model';

export const slice = createSlice({
  name: BANNERS_SLICE_NAME,
  initialState,
  reducers: {
    resetBannersListState() {
      return { ...initialState };
    },
    changePosition: (state: BannersState, action: PayloadAction<IBanner[]>) => {
      state.bannersList = {
        data: action.payload,
        meta: state.bannersList?.meta as IPagination,
      };
    },
    changeQuery: (state: BannersState, action: PayloadAction<TGetBannersQuery>) => {
      state.query = action.payload;
    },
    resetBanner(state: BannersState) {
      state.banner = initialState.banner;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getBannersList.fulfilled, (state: BannersState, action) => {
        state.bannersList = action.payload;
        state.isLoading = false;
      })
      .addCase(getBanner.fulfilled, (state: BannersState, action) => {
        state.banner = action.payload.data;
        state.isLoadingBanner = false;
      })
      .addCase(getBanner.pending, (state: BannersState) => {
        state.error = null;
        state.isLoadingBanner = true;
      })
      .addMatcher(isFulfilled(reorderBanners, createBanner, editBanner, deleteBanner), (state: BannersState) => {
        state.isLoading = false;
        state.error = null;
      })
      .addMatcher(
        isPending(getBannersList, reorderBanners, createBanner, editBanner, deleteBanner),
        (state: BannersState) => {
          state.isLoading = true;
          state.error = null;
        },
      )
      .addMatcher(
        isRejected(getBannersList, reorderBanners, createBanner, getBanner, editBanner, deleteBanner),
        (state: BannersState, action) => {
          const { error } = action;
          state.isLoading = false;
          state.isLoadingBanner = false;
          state.error = error;

          showApiErrors(error);
        },
      );
  },
});

export const { resetBannersListState, changeQuery, changePosition, resetBanner } = slice.actions;

export default slice.reducer;
